
export const checkToken = (params) => dispatch => {

  try {

    let status;
  
    return fetch(`/api/checkToken`,{method:"GET"})
      .then(res => {
        status = res.status;

        return res.status === 401 ? "" : res.json();
      })
      .then(res => {
        if (status === 200) {
          return dispatch(userLoged(res))
        } else {
          return dispatch(loginError(res.error));
        }
      })
      .catch(error => confirmAuth(false));

  } catch {}
}
  
export const login = (user, password) => dispatch => {

  const params = {
    method:'POST',
    headers:{'Content-Type': 'application/json'},
    body: JSON.stringify({
      email: user,
      password: password
    })
  };
  
  let status;
  return fetch(`/api/login`, params)
    .then(res => {
      status = res.status;
      return res.json();
    })
    .then(res => {
      if (status === 200) {
        return dispatch(userLoged(res))
      } else {
        return dispatch(loginError(res.error));
      }
    })
    .catch(error => console.log(error));
}

export const USER_LOGED = 'USER_LOGED'
export const userLoged = data => ({
  type: USER_LOGED,
  payload: {
    data: data
  }
})

export const CONFIRM_AUTH = 'CONFIRM_AUTH'
export const confirmAuth = data => ({
  type: CONFIRM_AUTH,
  payload: {
    data: data
  }
})

export const LOGIN_ERROR = 'LOGIN_ERROR'
export const loginError = error => ({
  type: LOGIN_ERROR,
  payload: {
    error: error
  }
})


export const logout = () => dispatch => {

  return fetch(`/api/logout`, {method: "POST"})
  
    .then(res => dispatch(userLogedOut(res)) )

    .catch(error => dispatch(catchError(error)));
}

export const USER_LOGEDOUT = 'USER_LOGEDOUT'
export const userLogedOut = data => ({
  type: USER_LOGEDOUT,
  payload: {
    data: data
  }
})



export const CONFIRM_EMAIL = 'CONFIRM_EMAIL'
export const ERROR_CONFIRM_EMAIL = 'ERROR_CONFIRM_EMAIL'

export const confirmEmail = (email) => dispatch => {

  const params = {
    method:'POST',
    headers:{'Content-Type': 'application/json'},
    body: JSON.stringify({
      email: email,
      
    })
  };
  
  let status;
  return fetch(`/api/confirmEmail`, params)
    .then(res => {
      status = res.status;
      return res.json();
    })
    .then(res => {
      if (status === 200) {
        return dispatch({
          type: CONFIRM_EMAIL,
          payload: {
            data: res
          }
        })
      } else {
        return dispatch({
          type: ERROR_CONFIRM_EMAIL,
          payload: {
            data: res
          }
        });
      }
    })
    .catch(error => console.log(error));
}



export const RESET_PWD_TOKEN = 'RESET_PWD_TOKEN'
export const ERROR_RESET_PWD_TOKEN = 'ERROR_RESET_PWD_TOKEN'

export const resetPwdToken = (token) => dispatch => {

  const params = {
    method:'POST',
    headers:{'Content-Type': 'application/json'},
    body: JSON.stringify({
      token: token,
    })
  };
  
  let status;
  return fetch(`/api/resetPwdToken`, params)
    .then(res => {
      status = res.status;
      return res.json();
    })
    .then(res => {
      if (status === 200) {
        return dispatch({
          type: RESET_PWD_TOKEN,
          payload: {
            data: res
          }
        })
      } else {
        return dispatch({
          type: ERROR_RESET_PWD_TOKEN,
          payload: {
            data: res
          }
        });
      }
    })
    .catch(error => console.log(error));
}


export const RESET_PWD = 'RESET_PWD'
export const ERROR_RESET_PWD = 'ERROR_RESET_PWD'

export const resetPwd = (newPwd, user) => dispatch => {

  const params = {
    method:'POST',
    headers:{'Content-Type': 'application/json'},
    body: JSON.stringify({
      pwd: newPwd,
      user: user,
    })
  };
  
  let status;
  return fetch(`/api/changepassword`, params)
    .then(res => {
      status = res.status;
      return res.json();
    })
    .then(res => {
      if (status === 200) {
        return dispatch({
          type: RESET_PWD,
          payload: {
            data: res
          }
        })
      } else {
        return dispatch({
          type: ERROR_RESET_PWD,
          payload: {
            data: res
          }
        });
      }
    })
    .catch(error => console.log(error));
}
